<template>
  <div class="form tab-content">
    <v-expansion-panels
      v-if="assetReservationObjects && assetReservationObjects.length > 0"
    >
      <v-expansion-panel
        v-for="(assetReservationObject, objectIndex) in assetReservationObjects"
        :key="objectIndex"
        style="margin: 0 20px"
      >
        <asset-reservation-object-panel
          :object-uuid="objectUuid"
          :original-asset-reservation-object="assetReservationObject"
          :disabled="disabled"
          :fields="fields"
          @update-loading="loading = $event"
          @update-asset-reservation-object="
            assetReservationObjects[objectIndex] = $event
          "
          @delete-asset-reservation-object="
            assetReservationObjects.splice(objectIndex, 1)
          "
        />
      </v-expansion-panel>
    </v-expansion-panels>
    <v-layout v-else row justify-center align-center style="height: 100px">
      <div class="message">
        {{ $t("NoAssetReservationsAssociatedWithObject") }}
      </div>
    </v-layout>
    <loading-spinner
      :active.sync="loading"
      :is-full-page="false"
      color="accent"
      background-color="transparent"
    />
  </div>
</template>

<script>
import LoadingSpinner from "vue-loading-overlay";
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import { mapActions } from "vuex";
import AssetReservationObjectPanel from "@/components/Home/Forms/_SpecialTabs/AssetReservationTab/AssetReservationObjectPanel";

export default {
  name: "AssetReservationTab",

  components: { AssetReservationObjectPanel, InputField, LoadingSpinner },

  props: {
    endpoint: {
      type: String,
      required: true
    },

    objectUuid: {
      type: String,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    fields: {
      type: Array
    }
  },

  data() {
    return {
      firstLoading: false,
      loading: false,

      assetReservationObjects: [],

      openPanel: null
    };
  },

  mounted() {
    if (this.endpoint && this.objectUuid) {
      this.getAssetReservationsObjects();
    }
  },

  methods: {
    ...mapActions(["getAssetReservationsByObject"]),

    async getAssetReservationsObjects() {
      this.firstLoading = true;
      try {
        this.assetReservationObjects = await this.getAssetReservationsByObject({
          objectEndpoint: this.endpoint,
          objectUUID: this.objectUuid
        });
      } catch (error) {
        console.log(error);
      }
      this.firstLoading = false;
    }
  }
};
</script>

<style scoped>
.message {
  color: #515358;
  padding: 4px 0;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/AssetReservationTab/AssetReservationTab.vue